"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFeatherFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.feather_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "feather_filled_svg__transparent_box" },
            React.createElement("path", { className: "feather_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "feather_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "feather_filled_svg__FILLED" },
            React.createElement("path", { d: "M29.56 6.09a15.64 15.64 0 00-8.66-2.15h-.29l-1.8 4.1-1.51-3.29-.67.25a76.15 76.15 0 00-7.1 3l-.4.2-1.23 3.72a27.13 27.13 0 005.84-1.72l.82 1.8c-.07 0-6.84 3-12.35 1.92l-.42 2.1a15.88 15.88 0 003.07.29 21.75 21.75 0 002.94-.22l4.9 2.95h.3a27.19 27.19 0 0010.11-2.23C28.58 14.55 30 7.5 30.05 7.2l.14-.72zM1.99 24h28v2h-28z" }))));
}
exports.default = SvgFeatherFilled;
//# sourceMappingURL=FeatherFilled.js.map